import { useSettings } from '@wix/tpa-settings/react';
import {
  useEnvironment,
  useExperiments,
  useTranslation,
} from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';

import { DataHook, Experiment } from '../../../../../../types';
import settingsParams from '../../../../settingsParams';
import { IconsDesktop, IconsMobile } from '../Icons';
import { classes } from './EmptyEditor.st.css';

interface EmptyEditorProps {
  setEditMode: (value: boolean) => void;
}

export const EmptyEditor: FC<EmptyEditorProps> = ({ setEditMode }) => {
  const settings = useSettings();
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const shouldShowExternalToolBar =
    isMobile && experiments.enabled(Experiment.EnableExternalToolbarMobile);

  const handleClick = () => {
    setEditMode(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  const placeholder =
    settings.get(settingsParams.aboutDescriptionPlaceholder) ||
    t('settings.texts-tab.placeholder-default-text');

  return (
    <>
      <div
        className={
          shouldShowExternalToolBar ? classes.rootMobile : classes.root
        }
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        data-hook={DataHook.EmptyEditor}
      >
        <Text tagName="div" className={classes.placeholder}>
          {placeholder}
        </Text>
        {!shouldShowExternalToolBar && <IconsDesktop />}
      </div>
      {shouldShowExternalToolBar && <IconsMobile />}
    </>
  );
};
